import CentroCultural from './CentroCultural';

export default CentroCultural;